import { BillingDataService } from './../_services/data-services/billing-data.service';
import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BillinConfirmGuard implements CanActivate {
  constructor(
    private router: Router,
    private billingDataService: BillingDataService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    const policyId = next.params['policyid'];

    return this.billingDataService.$billingDetailsEcheck.pipe(
      map((billingData) => {
        if (!billingData) {
          this.router.navigate(['/my-insurance', policyId, 'billing']);
          return false;
        } else {
          return true;
        }
      })
    );
  }
}
